/** TCG Live card names carry energy-symbol placeholders like `{G}`; expand them for display. */
const ENERGY: Record<string, string> = {
  G: "Grass",
  R: "Fire",
  W: "Water",
  L: "Lightning",
  P: "Psychic",
  F: "Fighting",
  D: "Darkness",
  M: "Metal",
  C: "Colorless",
  N: "Dragon",
  Y: "Fairy",
};

export function expandEnergyPlaceholders(name: string): string {
  return name.replace(/\{([A-Z])\}/g, (match, code: string) => ENERGY[code] ?? match);
}
